/**
 * Componente Frequencia List (frequencia-list)
 */
(function(){
	angular.module('frequenciaListModule').component('frequenciaList', {
		templateUrl: 'js/custom-components/frequencia-list/frequencia-list.component.html',
		controller: 'FrequenciaListComponentController',
		controllerAs: 'ctrl'
	});
})();